import type { Simplify } from '@festina-life/core'
import { createContext } from 'react'

export type DockingView = 'docked' | 'floating'

export type DockState = Simplify<'closed' | DockingView>

export type DockableLayoutContextType = {
  /**
   * Unique identifier of the `DockerModal` that is currently open,
   * and for which the `dockState` is relevant.
   */
  openKey: string | undefined
  setOpenKey: (openKey: string | undefined) => void
  dockState: DockState
  setDockState: (state: DockState) => void
  dockContainer: HTMLDivElement | undefined
  setDockContainer: (container: HTMLDivElement) => void
  preferredView: DockingView
}

export const DockableLayoutContext =
  createContext<DockableLayoutContextType | null>(null)
